import React from 'react';
import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';

function Subtitle() {
  const data = useTypedSelector(selectDetailedCarData);

  if (!data) {
    return null;
  }

  const {
    catalog: { complectation },
  } = data;

  return <Component>{complectation}</Component>;
}

export default Subtitle;

const Component = styled.div`
  font-size: 32px;
  font-weight: 300;
  color: ${(props) => props.theme.black};

  ${media.laptopOnly(css`
    font-size: 16px;
    line-height: 19px;
    margin-top: 6px;
  `)}

  ${media.tabletSmall(css`
    font-size: 26px;
    line-height: 29px;
  `)}

  ${media.mobile(css`
    font-size: 16px;
    line-height: 19px;
  `)}
`;
